import { FONT, COLORS } from "../../styles";
import { fmt } from "../../formatters";

export default function PeriodTable({ data, label, isCalendar }) {
  const rows = [
    ["Revenue Credits", fmt(data.totalCredits), COLORS.green],
    ["Operating Debits", fmt(data.totalDebits), COLORS.orange],
    ["Loan Repayments", fmt(data.loanPayments), COLORS.red],
    ["Loan Proceeds", fmt(data.loanProceeds), COLORS.blue],
    ["Net Cash Flow", fmt(data.totalCredits - data.totalDebits - data.loanPayments), data.totalCredits - data.totalDebits - data.loanPayments >= 0 ? COLORS.green : COLORS.red],
    ["Avg Balance", fmt(data.avgDailyBalance), COLORS.textSecondary],
    ["Min Balance", fmt(data.minBalance), data.minBalance < 5000 ? COLORS.red : COLORS.textSecondary],
  ];

  return (
    <div style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: 18, boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: isCalendar ? COLORS.primary : COLORS.textSecondary, marginBottom: 14, fontFamily: FONT, borderBottom: `1px solid ${COLORS.borderLight}`, paddingBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
        {isCalendar && <span style={{ fontSize: 10, background: COLORS.blueLight, color: COLORS.primary, padding: "2px 6px", borderRadius: 4, fontWeight: 600 }}>CAL</span>}
        {label}
      </div>
      {rows.map(([k, v, c]) => (
        <div key={k} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${COLORS.borderLight}` }}>
          <span style={{ fontSize: 12, color: COLORS.muted, fontFamily: FONT }}>{k}</span>
          <span style={{ fontSize: 13, color: c, fontFamily: FONT, fontWeight: 600 }}>{v}</span>
        </div>
      ))}
    </div>
  );
}
